import React from "react";

const AboutMe = () => {
  return (
    <div className="flex flex-col md:flex-row pb-6">
      <div className="w-full md:w-1/2 text-zinc-400 px-6 border-r-[1px] border-r-zinc-800 flex items-center">
        <div className="py-6">
          <h2 className="font-semibold mb-1">Hi! I'm Joseph Ige</h2>
          <p className="text-base leading-6 ">
            I build user-focused websites and web apps, merging functionality with creativity.
              As a creative designer, I explore bold ideas and transform them into purposeful digital experiences.
          </p>
        </div>
      </div>
      <div className="w-full md:w-1/2 p-6">
        <ul className="flex flex-col gap-1">
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan"> Stack:</span>
            React.js · Django 
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Focus:</span>
            Full Stack Dev.
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Freelance:</span>
            Available
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Design Toolset:</span>
            Adobe CC
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AboutMe;
